export { default, EmbeddedVideo } from './WistiaVideo';
